import config from '@config'
import {
  getAureusBatchRecommendations,
  GetAureusBatchRecommendationsResponse,
  Purpose,
} from '@utils/aureus'
import { JSONWidgetType as TeaserStandardVerticalVideoJSONWidgetType } from '@widgets/TeaserStandardVerticalVideo'

const {
  publication: { publication },
  backend: { deploymentEnv },
} = config

const isVideoRecommendationsEnabled = (): boolean => {
  const isRomandie = publication === 'romandie'

  return !isRomandie
}

interface AureusVideoRecommendationItem {
  aureusOfferId: string
  articleID: string
  teasers: {
    standardVerticalVideo: TeaserStandardVerticalVideoJSONWidgetType
  }
}

export type VideoRecommendationItem =
  TeaserStandardVerticalVideoJSONWidgetType & {
    articleId: string
    aureusOfferId: string
  }

type GetVideoRecommendationsAureus = (
  articleId: string,
  purpose?: Purpose
) => GetAureusBatchRecommendationsResponse<AureusVideoRecommendationItem>

const getVideoRecommendationsAureus: GetVideoRecommendationsAureus = (
  articleId,
  purpose
) =>
  getAureusBatchRecommendations<AureusVideoRecommendationItem>({
    'embedded-videos': {
      resultsLimit: 8,
      context: {
        section: `polaris-article-video-player-${deploymentEnv === 'prod' ? 'prod' : 'stg'}`,
        purpose: purpose || 'reference',
        contentBlacklist: articleId,
      },
    },
  } as const)

const getVideoRecommendations = async (id: string, purpose?: Purpose) => {
  let responseData: VideoRecommendationItem[] = []

  try {
    const queryResult = await getVideoRecommendationsAureus(id, purpose)

    responseData =
      queryResult?.results?.['embedded-videos']?.recommendations?.reduce(
        (acc, curr) => {
          acc.push({
            ...curr.teasers.standardVerticalVideo,
            articleId: curr.articleID,
            aureusOfferId: curr.aureusOfferId,
          } satisfies VideoRecommendationItem)

          return acc
        },
        [] as VideoRecommendationItem[]
      ) ?? []
  } catch {}

  return responseData
}
export { isVideoRecommendationsEnabled, getVideoRecommendations }
